import React from "react";
import { BRAND } from "@/data/brand";

// Reemplaça "Diesel PaCo" per un enllaç a www.dieselpaco.com dins de qualsevol text.
export function linkifyDieselPaco(text, className = "") {
  if (!text) return text;
  const parts = text.split(/(Diesel PaCo)/g);
  return parts.map((p, i) =>
    p === "Diesel PaCo" ? (
      <a
        key={i}
        href={BRAND.dieselPacoUrl}
        target="_blank"
        rel="noopener noreferrer"
        data-testid="dieselpaco-link"
        className={
          "text-[color:var(--dp-orange)] underline underline-offset-2 hover:opacity-80 transition-opacity " +
          className
        }
      >
        Diesel PaCo
      </a>
    ) : (
      <React.Fragment key={i}>{p}</React.Fragment>
    )
  );
}
